import { guestReplayLimitReachedToast } from '../auth/guestAccessCopy';
import { notifyApiUser } from '../common/apiNotification';
import { recordReplayView } from './replayApi';

type ReplayLimitError = Error & { code?: string };

const REPLAY_LIMIT_CODES = new Set([
  'REPLAY_NEW_GAME_LIMIT',
  'REPLAY_HISTORY_LIMIT',
]);

export function getReplayLimitToastMessage(
  error: unknown,
  isGuest: boolean,
): string | null {
  const code = (error as ReplayLimitError)?.code;
  if (!code || !REPLAY_LIMIT_CODES.has(code)) {
    return null;
  }

  if (isGuest) {
    return guestReplayLimitReachedToast;
  }

  return error instanceof Error ? error.message : null;
}

/** Records a replay view before navigation; returns false when blocked by entitlements. */
export async function recordReplayViewForSelect(
  gameId: string,
  isGuest: boolean,
): Promise<boolean> {
  try {
    await recordReplayView(gameId);
    return true;
  } catch (error) {
    const message =
      getReplayLimitToastMessage(error, isGuest) ??
      (error instanceof Error
        ? error.message
        : 'You cannot open this replay game right now.');
    notifyApiUser(message);
    return false;
  }
}
